import { defineRouting } from 'next-intl/routing';
import { APP_LOCALES, DEFAULT_LOCALE, RTL_LOCALES } from './localeConfig';

export const locales = APP_LOCALES;
export type AppLocale = (typeof locales)[number];

export const routing = defineRouting({
  locales: [...locales],
  defaultLocale: DEFAULT_LOCALE,
  /** Static export–friendly: every HTML file lives under `/{locale}/...`. */
  localePrefix: 'always',
});

export const rtlLocales = RTL_LOCALES;

export function textDirection(locale: string): 'ltr' | 'rtl' {
  return rtlLocales.has(locale) ? 'rtl' : 'ltr';
}
